<template>
  <div class="AdminClientsProductsManagementModule">
    <div class="HeaderContainer">
      <h3>
        掲載商品の表示設定をする
      </h3>

      <!-- カテゴリ一覧表示時 -->
      <template v-if="localIsCategorySelectedView">
        <div class="text-center">
          <h2 class="heading">
            商品カテゴリ
          </h2>
          <p>
            掲載するカテゴリを選択してください。
            カテゴリをクリックで商品の個別設定に移動出来ます。
          </p>
        </div>
      </template>

      <!-- 掲載商品一覧表示時 -->
      <template v-else>
        <div class="text-center">
          <h2 class="heading">
            {{ selectedCategoryName }}
          </h2>
          <VisualButton
            text="商品カテゴリに戻る"
            @click="_onClickReturnCategories()"
          />
          <p>
            掲載する商品を選択してください。
          </p>
        </div>
      </template>
    </div>

    <!-- カテゴリ一覧表示時 -->
    <div
      v-if="localIsCategorySelectedView"
      class="CardContainer"
    >
      <el-card
        v-for="item in categories"
        :key="item.id"
        class="Card clickable"
        :class="{
          isOnDisplay: isDisplayItem(item),
          isOffDisplay: !isDisplayItem(item)
        }"
        :body-style="{ padding: '0px' }"
        shadow="never"
      >
        <div class="SwitchContainer">
          <el-radio-group
            v-model="item.indivDisplaySetting"
            :disabled="isSetConfigSourceClientGroupId"
            @change="changeIndivDisplaySetting(item, 'category')"
          >
            <el-radio label="unset">未設定</el-radio>
            <el-radio label="indivDisplay">表示</el-radio>
            <el-radio label="indivHidden">非表示</el-radio>
          </el-radio-group>
        </div>
        <div class="CardInner">
          <img
            @click="selectCategory(item)"
            :src="item.imageUrl"
            :alt="item.name"
            class="CardImage"
          />
          <div>
            <span class="Title">{{ item.name }}</span>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 掲載商品一覧表示時 -->
    <div
      v-else
      class="CardContainer"
    >
      <!-- Product Selection -->
      <el-card
        v-for="product in products"
        :id="product.id"
        :key="product.id"
        class="Card"
        :class="{
          isOnDisplay: isDisplayItem(product),
          isOffDisplay: !isDisplayItem(product)
        }"
        :body-style="{ padding: '0px'}"
        shadow="never"
      >
        <div class="SwitchContainer">
          <el-radio-group
            v-model="product.indivDisplaySetting"
            :disabled="isSetConfigSourceClientGroupId"
            @change="changeIndivDisplaySetting(product, 'product')"
          >
            <el-radio label="unset">未設定</el-radio>
            <el-radio label="indivDisplay">表示</el-radio>
            <el-radio label="indivHidden">非表示</el-radio>
          </el-radio-group>
        </div>
        <div class="CardInner">
          <img
            :src="product.imageUrl[0]"
            :alt="product.name"
            class="CardImage"
          />
          <div class="ProductNumber">{{ product.number }}</div>
          <div>{{ product.name }}</div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import VisualButton from "@/components/VisualButton";

export default {
  name: "AdminClientsProductsManagementModule",
  components: {
    VisualButton,
  },
  props: {
    categories: {
      type: Array,
      default: () => {
        return [];
      },
    },
    products: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedCategoryName: {
      type: String,
    },
    isCategorySelectedView: {
      type: Boolean,
      default: false,
    },
    isSetConfigSourceClientGroupId: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {};
  },
  computed: {
    localIsCategorySelectedView: {
      get () {
        return this.isCategorySelectedView;
      },
      set (value) {
        this.$emit("update:isCategorySelectedView", value);
      },
    },
  },
  methods: {
    /**
     * Send emit which category the user selected
     * @param {any} item category object
     */
    selectCategory (item) {
      this.$emit("update:selectCategory", item);
    },
    /**
     * Send with emit each time a radio button check changes.
     * f the category or product radio button changes, create an object for the change in "this.updateInput"
     * @param {object} item category or product object
     * @param {string} type 'category' or 'product'
     */
    changeIndivDisplaySetting (item, type) {
      this.$nextTick(() => {
        const params = {
          ...item,
          showArrayKey: type === "category" ? "showCategories" : "showProducts",
          hideArrayKey: type === "category" ? "hideCategories" : "hideProducts",
          type,
        };
        this.$emit("update:indivDisplaySetting", params);
        // UIが更新されず苦肉の策で強制アップデート
        this.$forceUpdate();
      });
    },
    /**
     * Manage card display status
     * @param {any} item category or product object
     * @returns {boolean}
     */
    isDisplayItem (item) {
      const { indivDisplaySetting } = item;
      if (indivDisplaySetting === "indivDisplay") {
        return true;
      } else if (indivDisplaySetting === "indivHidden") {
        return false;
      } else {
        return item.display;
      }
    },

    _onClickReturnCategories () {
      this.localIsCategorySelectedView = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

$--gap: 25px;
$--borderWidth: 2px;

.AdminClientsProductsManagementModule {
  position:relative;

  .HeaderContainer {
    margin: $--gap;

    .heading {
      font-size: 2em;
      line-height: 1.03;
      margin: 0 0 16px 0;
    }
  }

  .CardContainer {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: $--gap;
    margin: $--gap;
    text-align: center;

    @media (max-width: 1366px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
    }

    .SwitchContainer {
      padding: 15px 10px 0 10px;

      .CheckBox {
        margin-right: 15px;
      }
    }
  }

  .Card {
    border-width: $--borderWidth;

    &.clickable {
      cursor: pointer;
    }

    &.isOnDisplay {
      border: $--borderWidth solid $--color-primary;
    }

    &.isOffDisplay {
      // border: $--borderWidth solid $red-base;

      .CardInner {
        opacity: 0.2;
      }
    }

    .CardInner {
      position: relative;
      padding: 10px 0;

      .CardImage {
        width: 100%;
      }

      .Title {
        font-weight: bold;
      }

      .ProductNumber {
        font-weight: bold;
      }
    }
  }
}
</style>
